interface BookingEvent {
  event: string;
  bookingType: 'consultation' | 'bootcamp' | 'expert-session';
  eventCategory: 'Booking';
  eventAction: 'Click' | 'Success' | 'Error';
  eventLabel: string;
  value?: number;
  currency?: string;
  campaignData?: {
    source?: string;
    medium?: string;
    campaign?: string;
    content?: string;
    term?: string;
  };
}

declare global {
  interface Window {
    dataLayer: any[];
  }
}

const DEBUG = import.meta.env.DEV;

export const pushBookingEvent = (config: Omit<BookingEvent, 'event'>) => {
  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];

  // Get UTM parameters from URL
  const urlParams = new URLSearchParams(window.location.search);
  const campaignData = {
    source: urlParams.get('utm_source') || undefined,
    medium: urlParams.get('utm_medium') || undefined,
    campaign: urlParams.get('utm_campaign') || undefined,
    content: urlParams.get('utm_content') || undefined,
    term: urlParams.get('utm_term') || undefined,
  };

  const eventData = {
    event: 'booking_action',
    ...config,
    campaignData: {
      ...campaignData,
      ...config.campaignData,
    },
    timestamp: new Date().toISOString(),
  };

  // Push to dataLayer
  window.dataLayer.push(eventData);

  // Debug logging in development
  if (DEBUG) {
    console.group('🔍 GTM Event Pushed:');
    console.log('Event Name:', eventData.event);
    console.log('Booking Type:', eventData.bookingType);
    console.log('Action:', eventData.eventAction);
    console.log('Label:', eventData.eventLabel);
    console.log('Campaign Data:', eventData.campaignData);
    console.log('Full Event:', eventData);
    console.groupEnd();
  }
};

export const trackBookingClick = (
  bookingType: BookingEvent['bookingType'],
  calendarUrl: string,
  value?: number
) => {
  // Track the click event
  pushBookingEvent({
    bookingType,
    eventCategory: 'Booking',
    eventAction: 'Click',
    eventLabel: calendarUrl,
    value,
    currency: value ? 'USD' : undefined,
  });

  // Debug logging in development
  if (DEBUG) {
    console.log('🔄 Redirecting to:', calendarUrl);
  }

  // Delay redirect slightly to ensure tracking fires
  setTimeout(() => {
    window.open(calendarUrl, '_blank');
  }, 100);
};
